

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { CountryList } from "../../components/CountryList";


export const CountryListPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Country List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Country List", navigateTo: "/country/list" }
      ]}
      mainContents={<CountryList />}
    />
  );
};
